import NavBar from "./reusable-components/nav-bar";
import Rectangle from '../images/Rectangle.png';
import Button from "react-bootstrap/Button";
import CommunityBanner from '../images/CommunityPageBanner.png';
import ReferFriendBG from '../images/referFriendBG.png';
import FindAStore from "./reusable-components/FindAStore";
import ShopIQOS from "./reusable-components/ShopIQOS";
import Footer from "./reusable-components/footer";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import LatestPosts from '../images/LatestPostImage.png';
import DashboardImage from '../images/CommunityDashboardImage.png';
import HeartOutline from '../images/HeartOutline.png';
import CommentOutline from '../images/CommentOutline.png';
import Section from './myfriends';
import Members from './newMembers';

function CommunityPage() {
    return (

        <div>
            <div>
                <NavBar />
            </div>
            <div >
                <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
            </div>
            <div>
                <img src={CommunityBanner} style={{ width: '100%', height: '200px' }} alt="" />
            </div>
            <div style={{
                fontFamily: 'Sintony',
                textAlign: 'center',
                marginTop: '20px',
                marginLeft: '20px',
                marginRight: '20px'
            }}>
                <span style={{
                    color: '#475666',
                    fontSize: '13px',
                    fontWeight: '700',

                }}
                >
                    {/* DASHBOARD */}
                </span>
                <div>
                    <div>
                        <img src={DashboardImage} style={{ width: '100%', height: '100%' }} alt="" />
                    </div>
                </div>
            </div>
            <div style={{
                fontFamily: 'Sintony',
                textAlign: 'center',
                marginTop: '20px',
                marginLeft: '20px',
                marginRight: '20px'

            }}>
                <span style={{
                    color: '#475666',
                    fontSize: '13px',
                    fontWeight: '700'

                }}
                >LATEST POSTS</span>
                <div>
                    <div style={{
                        marginTop: '20px'
                    }}>
                        <img src={LatestPosts} style={{ width: '100%', height: '100%' }} alt="" />
                    </div>
                    <div>
                        <p style={{
                            color: '#475666',
                            fontSize: '12px',
                            fontWeight: '400',
                            marginTop: '20px',
                            lineHeight: '15.64px'

                        }}>
                            Relaxing after work with my new Duo. Anyone else loving how easy this product is to use?
                        </p>
                        <div style={{
                            marginTop: '20px'
                        }}>
                            <img src={HeartOutline} style={{ width: '13px', height: '13px' }} alt="" />
                            <span style={{
                                color: '#475666',
                                fontFamily: 'Sintony',
                                fontSize: '11px',
                                fontWeight: '400',
                                lineHeight: '14.33px',
                                marginLeft: '2px'

                            }}> 28 LIKES</span>
                            <img src={CommentOutline} style={{ width: '13px', height: '13px', marginLeft: '20px' }} alt="" />
                            <span style={{
                                color: '#475666',
                                fontFamily: 'Sintony',
                                fontSize: '11px',
                                fontWeight: '400',
                                lineHeight: '14.33px',
                                marginLeft: '2px'

                            }}> 64 COMMENTS</span>
                        </div>
                        <Button variant="success" size="lg" type="submit" style={{
                            height: '43px',
                            width: '123px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            backgroundColor: '#00A78A',
                            borderColor: '#FFFFFF',
                            marginTop: '25px'

                        }} >
                            ADD A POST
                        </Button>
                    </div>
                </div>
            </div>
            <div style={{
                textAlign: 'center',
                marginTop: '30px'
            }}>
                <span style={{
                    color: '#475666',
                    fontSize: '13px',
                    fontWeight: '700'

                }}
                >MY FRIENDS</span>
                <div>
                    <Section />
                </div>
            </div>
            <div style={{
                height: '250px',
                width: '100%',
                backgroundImage: `url(${ReferFriendBG})`,
                backgroundRepeat: 'no-repeat',
                marginTop: '20px',
                marginBottom: '20px'
            }}>
                <div style={{

                    textAlign: 'left',

                    color: '#FFFFFF',
                    paddingTop: '85px',
                    paddingLeft: '20px'
                }}>
                    <div style={{
                        fontSize: '17px',
                        fontWeight: '700',
                        font: 'Sintony',
                        lineHeight: '21px'

                    }}>
                        Need a HeatStick? <br></br>Your community can help!
                    </div>
                    <div style={{
                        marginTop: '10px'
                    }}>
                        <Button variant="outline-secondary" size="lg" type="submit" style={{
                            height: '43px',
                            width: '123px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF'

                        }} >
                            CONNECT NOW
                        </Button>
                    </div>
                </div>
            </div>
            <div style={{
                textAlign: 'center'
            }}>
                <span style={{
                    color: '#475666',
                    fontSize: '13px',
                    fontWeight: '700',


                }}
                >NEW MEMBERS</span>
                <div style={{
                    border: '1px',
                    borderColor: '#DFDFDF'
                }}>
                    <Members />
                </div>
            </div>
            <div style={{
                marginTop: '20px',
                marginBottom: '20px'
            }}>
                <Row>
                    <Col>
                        <ShopIQOS />
                    </Col>
                    <Col>
                        <FindAStore />
                    </Col>
                </Row>
            </div>
            <Footer />
        </div>
    );
}

export default CommunityPage;